// auto-generated by Typewriter template _models.tst from PortCall.Models\Vessels\BowThruster.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { NullableMeasurement, NullableMeasurementData, NullableMeasurementOptions } from 'data/models/Measurement';

// BowThrusterData is the class that BowThruster serializes to/from
export interface BowThrusterData {
	
	
    Present : boolean | null;
    Size : NullableMeasurementData;
}

// BowThrusterOptions is the class which may be passed to the BowThruster constructor to define optional initial data values
export interface BowThrusterOptions {
	
	
    Present? : boolean | null;
    Size? : NullableMeasurementOptions;
}

export class BowThruster {
	
	
    public Present : DataSignal<boolean | null>;
    public Size : NullableMeasurement;

    constructor();
    constructor(data : BowThrusterOptions);
    constructor(data: BowThrusterOptions | null = null) {
	    
	    
        this.Present = jsonableObservable(S.value<boolean | null>(data && data.Present !== undefined ? data.Present : null));
        this.Size = data && data.Size !== undefined ? new NullableMeasurement(data.Size) : new NullableMeasurement();
    }

    static key(obj : BowThruster) {
        return ;
    }
    
    static dataKey(obj : BowThrusterOptions) {
        return ;
    }

    static update(obj : BowThruster, data : BowThrusterOptions) {
        S.freeze(() => {
	        
	        
            if (data.Present !== undefined) obj.Present(data.Present);
            if (data.Size !== undefined) NullableMeasurement.update(obj.Size, data.Size);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/BowThruster.ts